module.exports = __webpack_public_path__ + "img/c-thermometer-img8-2.b580dc7d.png";